import React from "react";

/** Shown inside the page while a protected route waits for the login check. */
const AuthCheckSpinner: React.FC = () => (
  <div className="flex justify-center items-center min-h-[60vh]" role="status" aria-label="Checking login">
    <span className="w-8 h-8 rounded-full border-4 border-[#009fe3]/20 border-t-[#009fe3] animate-spin" />
  </div>
);

export default AuthCheckSpinner;
